BX.Vue.component('aos__docs-sms-sign',
    {
        data: function () {
            return {
                fieldSMS: null,
                attemptConnection: 0,
                timeoutConnection: 120,
                timeoutGetDocsForSignConnection: 300,
                flags: {
                    sendCode: false
                },
                timer: {
                    end: 180
                }
            };
        },
        computed: {
            subtitle: (vm) => vm.$parent.msg('A_AOS_DOCS_SMS_SIGN_SUBTITLE'),
            desc: (vm) => vm.$parent.msg('A_AOS_DOCS_SMS_SIGN_CODE')
        },
        methods: {
            init: function (method, values) {
                const vm = this;

                if (typeof values !== 'object') {
                    values = {};
                }

                let initFieldSMS = () => {
                    vm.fieldSMS = new AFieldSms({
                        actions: {
                            resend: function () {
                                vm.validatePhoneResendAction(true, '', initFieldSMS);
                            },
                            send: function (value) {
                                vm.validatePhoneCodeAction(true, '', value);
                            },
                        },
                        template: 'aos',
                        values: Object.assign({
                            autoInitial: true,
                            autoSend: true,
                            phone: vm.$parent.phone,
                            disclaimer: vm.$parent.msg('A_AOS_DOCS_SMS_SIGN_DISCLAIMER'),
                            position: 'left',
                            showTimer: true,
                            isForm: false,
                            elementType: 'label'
                        }, values)
                    });
                    vm.fieldSMS.create(vm.$refs.form, vm.timer.end);
                }

                vm.validatePhoneResendAction(true, '', initFieldSMS);
            },
            validatePhoneCodeAction: function (isWaitingStart, id, code) {
                let vm = this;
                let fieldSms = vm.$refs.form.querySelector('.form__field-sms');

                if (isWaitingStart && vm.flags.sendCode) {
                    return false;
                }

                if (BX.type.isNil(code)) {
                    let confirmationCode = vm.$refs.form.querySelector('[name="confirmation_code"]');
                    if (!confirmationCode) return false;
                    code = confirmationCode.value;
                }

                if (isWaitingStart) {
                    vm.flags.sendCode = true;
                    vm.attemptConnection = vm.$parent.options.timeoutConnection;

                    vm.$parent.blurLoader(vm.$parent.aos, true);
                } else {
                    if (vm.attemptConnection > 0) {
                        --vm.attemptConnection;
                    } else {
                        vm.attemptConnection = 0;
                    }
                }

                BX.ajax.runComponentAction(
                    'aton:aos',
                    'docsSignRequest',
                    {
                        url: location.pathname,
                        method: 'post',
                        mode: 'class',
                        data: {
                            isWaiting: vm.attemptConnection > 0 ? 'Y' : 'N',
                            id: id ? id : '',
                            code: code,
                            isSubscribe: null,
                            phone: vm.$parent.phone
                        },
                    }
                ).then(function (request) {
                    vm.flags.sendCode = false;
                    if (request.status === 'success') {
                        let requestData = request.data;

                        if (requestData.ymGoalCode && typeof ym !== 'undefined') {
                            ym(28725931, 'reachGoal', requestData.ymGoalCode);
                        }
                        if (requestData.status === 'success') {
                            vm.fieldSMS.destroy();
                            vm.fieldSMS = null;
                            vm.$parent.blurLoader(vm.$parent.aos, false);
                            vm.$parent.step = 'FINAL';
                        } else if (requestData.status === 'waiting') {
                            setTimeout(function () {
                                vm.validatePhoneCodeAction(false, requestData.data.id);
                            }, 1000);
                        } else if (requestData.status === 'error') {

                            //let fieldSmsTimer = vm.$refs.aosSubscribe.querySelector('.time__to-end');
                            //let fieldSmsDesc = vm.$refs.aosSubscribe.querySelector('.form_desc');
                            if (requestData.data.hidePhoneCode === 'Y') {
                                vm.fieldSMS.destroy();
                                vm.fieldSMS = null;
                                vm.$parent.step = 'DOCS_FOR_SIGN';
                                // fieldSmsTimer.style.display = 'none';
                                // fieldSms.style.display = 'none';
                                // fieldSmsDesc.style.display = 'none';
                                // vm.fieldSMS.timerReset();
                            } else {
                                //fieldSmsTimer.style.display = 'block';
                            }

                            if (requestData.message.includes('#LINK_RESEND#')) {
                                vm.$parent.messageError(requestData.message.replace('#LINK_RESEND#', vm.$parent.msg('A_AOS_INITIAL_DATA_SMS_RESEND')));
                            } else {
                                vm.$parent.messageError(requestData.message);
                            }

                            vm.fieldSMS.base.resetValues(fieldSms, true);
                            fieldSms.classList.add('form__field_error');

                            fieldSms.addEventListener('click', () => {
                                fieldSms.classList.remove('form__field_error');
                            }, {once: true});

                            fieldSms.classList.add('form__field_error');
                            vm.$parent.blurLoader(vm.$parent.aos, false);
                        }
                    } else {
                        vm.$parent.messageError(vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'));
                        vm.$parent.blurLoader(vm.$parent.aos, false);
                    }
                }).catch(function () {
                    vm.flags.sendCode = false;
                    vm.$parent.messageError(vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'));
                    vm.$parent.blurLoader(vm.$parent.aos, false);
                });
            },
            validatePhoneResendAction: function (isWaitingStart, id, callback) {
                let vm = this;

                if (isWaitingStart) {
                    vm.$parent.blurLoader(vm.$parent.aos, true);
                    vm.attemptConnection = vm.timeoutConnection;
                } else {
                    if (vm.attemptConnection > 0) {
                        --vm.attemptConnection;
                    } else {
                        vm.attemptConnection = 0;
                    }
                }

                BX.ajax.runComponentAction(
                    'aton:aos',
                    'docsSignReady',
                    {
                        url: location.pathname,
                        method: 'post',
                        mode: 'class',
                        data: {
                            data: {
                                is_waiting: vm.attemptConnection > 0 ? 'Y' : 'N',
                                id: id ? id : ''
                            }
                        },
                    }
                ).then(function (request) {
                    let requestData = request.data;
                    if (requestData.status === 'success') {
                        if(requestData?.message) {
                            vm.$parent.messageError(requestData.message);
                        }

                        if (vm.fieldSMS) {
                            vm.fieldSMS.destroy();
                            vm.fieldSMS = null;
                            vm.$refs.form.innerHTML = '';
                        }

                        if (typeof callback === 'function') {
                            callback();
                        }

                        vm.$parent.removeMessageError();
                        vm.$parent.blurLoader(vm.$parent.aos, false);
                    } else if (requestData.status === 'waiting') {
                        setTimeout(() => {
                            vm.validatePhoneResendAction(false, requestData.data.id, callback);
                        }, 1000);
                    } else if (requestData.status === 'error') {
                        vm.$parent.messageError(requestData.message);
                        vm.$parent.blurLoader(vm.$parent.aos, false);
                    } else {
                        vm.$parent.messageError(requestData.message);
                        vm.$parent.blurLoader(vm.$parent.aos, false);
                    }
                }).catch(function () {
                    vm.$parent.messageError(vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'));
                    vm.$parent.blurLoader(vm.$parent.aos, false);
                });
            },
        },
        mounted: function () {
            const vm = this;
            vm.$parent.titleClass = 'ocf__section-title__docs_sms_sign';
            vm.$parent.title = vm.$parent.msg('A_AOS_DOCS_SMS_SIGN_TITLE');
            vm.init();
            vm.$parent.removeMessageError();
            vm.$parent.scrollToElement('._aos', 0);
        },
        template: `
          <div ref="aosSubscribe" class="aos__docs-sms-sign aos__subscribe">
          <div class="ocf__section ocf__section-visible">
            <div class="ocf__block ocf__info-wrap">
              <form  class="form __wrap aos__subscribe-container">
                <span v-if="$parent?.phone" class="form_subtitle"
                      v-html="subtitle.replace('#REPLACE#', $parent?.phone)"/>
                <span class="form_desc" v-html="desc"/>
                <div ref="form" class="field-sms"/>
              </form>
            </div>
          </div>
          </div>
        `,
    }
);